import authInstance from '../authInstance';
import {
  CreateActivityPayload,
  ActivityQueryParams,
  ActivityResponse,
  ActivityLog,
} from '../types/activity.types';

/**
 * Activity Service
 * Handles all activity-related API calls
 */

/**
 * Create a new activity log entry
 * @param payload - Activity data
 */
export const createActivity = async (
  payload: CreateActivityPayload
): Promise<ActivityLog> => {
  try {
    const response = await authInstance.post('/user/activities', payload);
    return response.data.data;
  } catch (error) {
    console.error('[ActivityService] Failed to create activity:', error);
    throw error;
  }
};

/**
 * Get all activities (superadmin only)
 * @param params - Query parameters
 */
export const getActivities = async (
  params?: ActivityQueryParams
): Promise<ActivityResponse> => {
  try {
    const response = await authInstance.get('/superAdmin/activities', {
      params,
    });
    return response.data;
  } catch (error) {
    console.error('[ActivityService] Failed to fetch activities:', error);
    throw error;
  }
};

/**
 * Get current user's activities
 * @param params - Query parameters
 */
export const getMyActivities = async (
  params?: ActivityQueryParams
): Promise<ActivityResponse> => {
  try {
    const response = await authInstance.get('/user/activities/me', {
      params,
    });
    return response.data;
  } catch (error) {
    console.error('[ActivityService] Failed to fetch my activities:', error);
    throw error;
  }
};

/**
 * Delete an activity (superadmin only)
 * @param id - Activity ID
 */
export const deleteActivity = async (id: string): Promise<void> => {
  try {
    await authInstance.delete(`/superAdmin/activities/${id}`);
  } catch (error) {
    console.error('[ActivityService] Failed to delete activity:', error);
    throw error;
  }
};

/**
 * Bulk delete activities (superadmin only)
 * @param ids - Activity IDs
 */
export const bulkDeleteActivities = async (ids: string[]): Promise<void> => {
  try {
    await authInstance.post('/superAdmin/activities/bulk-delete', { ids });
  } catch (error) {
    console.error('[ActivityService] Failed to bulk delete activities:', error);
    throw error;
  }
};
